import { SystemService } from '$services/system/system.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  backendIsAlive: boolean = false;

  constructor(private readonly system:SystemService){}

  ngOnInit(): void {
    this.system.pingIfBackendIsAlive().subscribe(
      {
        next: ()=>{
          this.backendIsAlive = true
        },
        error: (err)=>{
          this.backendIsAlive = false
          console.error(err)
        }
      }
    )
  }
  isLogged: boolean = false

  
}
